<!--
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-27 10:42:12
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="tag-cell">
        <el-tag>{{ row.tag_name }}</el-tag>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	computed: {},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped></style>
